import React from 'react';
import { ComponentLoaderMap } from '@/utils/types/ComponentLoaderMap';
// Single Templates
import { createContext, lazy, Suspense, useEffect, useState } from 'react';
import { ScrollRestoration } from 'react-router-dom';
import { afLength } from '@/utils/helpers';
import { afGetPost } from '@/utils/api';
import Loading from '@/components/shared/Loading';
import { TemplateLoaderProps } from '@/utils/types/TemplateLoaderProps';
import { TemplateProps } from '@/utils/types/TemplateProps';
import { APIResult } from '@/utils/types/APIResult';
import { Post } from '@/utils/types/Post';
// const AFAnnouncement = lazy( () => import( '@/components/templates/single/AFAnnouncement' ) );
// const AFAnalystReport = lazy( () => import( '@/components/templates/single/AFAnalystReport' ) );
const AFBlog = lazy( () => import( '@/components/templates/single/AFBlog' ) );
// const AFCustomerStory = lazy( () => import( '@/components/templates/single/AFCustomerStory' ) );
// const AFEvent = lazy( () => import( '@/components/templates/single/AFEvent' ) );
const AFForm = lazy( () => import( '@/components/templates/single/AFForm' ) );
// const AFGlossary = lazy( () => import( '@/components/templates/single/AFGlossary' ) );
// const AFLegal = lazy( () => import( '@/components/templates/single/AFLegal' ) );
// const AFMediaCoverage = lazy( () => import( '@/components/templates/single/AFMediaCoverage' ) );
// const AFPodcast = lazy( () => import( '@/components/templates/single/AFPodcast' ) );
// const AFPressRelease = lazy( () => import( '@/components/templates/single/AFPressRelease' ) );
const AFSimplePage = lazy( () => import( '@/components/templates/single/AFSimplePage' ) );
// const AFTopic = lazy( () => import( '@/components/templates/single/AFTopic' ) );
// const AFVideo = lazy( () => import( '@/components/templates/single/AFVideo' ) );
// const AFWhitePaper = lazy( () => import( '@/components/templates/single/AFWhitePaper' ) );
// const Attachment = lazy( () => import( '@/components/templates/single/Attachment' ) );
// const DefaultSingle = lazy( () => import( '@/components/templates/single/DefaultSingle' ) );
const LandingPage = lazy( () => import( '@/components/templates/LandingPage' ) );
const Page404 = lazy( () => import( '@/components/templates/Page404' ) );

const templates: ComponentLoaderMap = {
    // 'about': LandingPage,
    // 'ad': LandingPage,
    // 'analyst-report': AFAnalystReport,
    // 'announcement': AFAnnouncement,
    'blog': AFBlog,
    // 'customer-story': AFCustomerStory,
    // 'default': DefaultSingle,
    // 'event': AFEvent,
    'form': AFForm,
    // 'glossary': AFGlossary,
    'landing-page': LandingPage,
    // 'legal': AFLegal,
    // 'location': LandingPage,
    // 'media-library': Attachment,
    // 'media-coverage': AFMediaCoverage,
    // 'podcast': AFPodcast,
    // 'press-release': AFPressRelease,
    'simple-page': AFSimplePage,
    // 'topic': AFTopic,
    // 'video': AFVideo,
    // 'white-paper': AFWhitePaper,
    '404': Page404,
};

export const PageSlugContext = createContext('');

const TemplateLoader: React.FC<TemplateLoaderProps> = ( { 
    iframe = false, 
    postType, 
    queryString = '', 
    slug, 
    layoutClassesFunction 
} ) => {
    const [ post, setPost ] = useState<Post | undefined>( undefined );
    const [ TemplateName, setTemplateName ] = useState<React.FC<TemplateProps>>();
    let finalPostType: string = postType;
    if ( finalPostType === 'media' ) {
        // rename
        finalPostType = 'media-library';
    }
    else if ( finalPostType === 'page' ) {
        // rename
        finalPostType = 'simple-page';
    }
    useEffect( () => {
        async function fetchData() {
            await afGetPost( finalPostType, slug, queryString ).then( ( data: APIResult ) => {
                if ( data.json ) {
                    setPost( data.json as Post );
                    const template: React.FC<TemplateProps> = templates[ finalPostType ] ? templates[ finalPostType ] : templates.default;
                    setTemplateName( template );
                } 
                else {
                    setPost( undefined );
                    setTemplateName( templates['404'] );
                }
            } );
        }
        fetchData();
    }, [ slug ] );
    if ( TemplateName && post ) {
            return (
                <Suspense fallback={ <Loading /> }>
                    <PageSlugContext.Provider value={ slug }>
                        <TemplateName post={ post } iframe={ iframe ? iframe : false } layoutClasses={ layoutClassesFunction } />
                    </PageSlugContext.Provider>
                    <ScrollRestoration />
                </Suspense>
            );
    } else {
        return null;
    }
}
export default TemplateLoader;